import { useFormContext } from 'react-hook-form';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpErrorMessage, EpRadioButton, EpStepContent } from '../components';

export default function NotificationMoreInfoInput({
  translations,
  origem
}: {
  translations: unknown;
  origem: string;
}) {
  const controller = 'notificationMoreInfoInput';
  const { formState: { errors }, setValue, getValues } = useFormContext();

  if (!getValues('notificationMoreInfoInput.inputValue') && origem === 'pharmacy') {
    setValue('notificationMoreInfoInput.inputValue', '1');
  }

  return (
    <EpStepContent.Label label={t(translations, 'Incident time') + ' *'}>
      <EpRadioButton
        radioId={`EpRadio__0`}
        radioValue={'1'}
        radioName={controller}
        radioLabel={t(translations, 'Morning: 6 a.m. and 11:59 a.m')}
        errorMessage={t(translations, '* Required Fied')}
        radioWithError={!!errors[controller]}
      />
      <EpRadioButton
        radioId={`EpRadio__1`}
        radioValue={'2'}
        radioName={controller}
        radioLabel={t(translations, 'Afternoon: 12 a.m. and 5:59 p.m')}
        errorMessage={t(translations, '* Required Fied')}
        radioWithError={!!errors[controller]}
      />
      <EpRadioButton
        radioId={`EpRadio__2`}
        radioValue={'3'}
        radioName={controller}
        radioLabel={t(translations, 'Night: 6 p.m. and 11:59 p.m')}
        errorMessage={t(translations, '* Required Fied')}
        radioWithError={!!errors[controller]}
      />
      <EpRadioButton
        radioId={`EpRadio__3`}
        radioValue={'4'}
        radioName={controller}
        radioLabel={t(translations, 'Overnight: 12 p.m. and 05:59 a.m')}
        errorMessage={t(translations, '* Required Fied')}
        radioWithError={!!errors[controller]}
      />
      <EpErrorMessage inputName={controller} />
    </EpStepContent.Label>
  );
}
